import { GeneralListingsService } from '@/hub-shared'
import Category from '@/interfaces/category.interface'
import onCategoriesChange, { onLoadingCategories } from '@observables/categories.observable'
import { BehaviorSubject, Subject } from 'rxjs'
import { take, takeUntil } from 'rxjs/operators'

export default class CategoriesHelper {
  generalListingsService: GeneralListingsService
  mainObservable: BehaviorSubject<Array<Category>> = onCategoriesChange
  waitObservable: BehaviorSubject<Array<Category>> = onCategoriesChange
  loadingCategories = false
  notifier = new Subject()

  constructor() {
    this.generalListingsService = new GeneralListingsService()
  }

  async getCategories(): Promise<Array<Category>> {
    return new Promise((resolve) => {
      this.mainObservable
        .pipe(take(1))
        .subscribe(async (categories: Array<Category>) => {
          let categoriesToReturn: Array<Category> = categories
          if (!categories?.length) {
            onLoadingCategories
              .pipe(take(1))
              .subscribe(async (loading: boolean) => {
                if (!loading) {
                  this.loadingCategories = true
                  onLoadingCategories.next(true)
                  categoriesToReturn = await this.generalListingsService.getCategoriesWithChildren()
                  onCategoriesChange.next(categoriesToReturn)
                  this.loadingCategories = false
                  onLoadingCategories.next(false)
                  resolve(categoriesToReturn)
                } else if (!this.loadingCategories) {
                  this.waitObservable.pipe(takeUntil(this.notifier)).subscribe((newCategories) => {
                    categoriesToReturn = newCategories
                    if (categoriesToReturn?.length) {
                      resolve(categoriesToReturn)
                      this.notifier.next(undefined)
                      this.notifier.complete()
                    }
                  })
                }
              })
              .unsubscribe()
          } else {
            resolve(categoriesToReturn)
          }
        })
        .unsubscribe()
    })
  }
}
